// Based on https://blog.logrocket.com/how-to-autofocus-using-react-hooks/
import { useRef, useCallback } from "react";

export default function useAutofocusRef<T extends HTMLElement = any>(): [
  React.RefCallback<T>,
  React.RefObject<T | null>,
] {
  const ref = useRef<T | null>(null);

  const refCallback = useCallback((inputElement: T) => {
    if (ref.current == null) {
      inputElement.focus();
    }
    ref.current = inputElement;
  }, []);

  return [refCallback, ref];
}
